/**
 * Format number according to locale
 */
export const formatNumber = (
  value: number,
  locale: string = 'ar',
  options?: Intl.NumberFormatOptions
): string => {
  const localeCode = locale === 'ar' ? 'ar-SA' : 'en-US';
  return new Intl.NumberFormat(localeCode, {
    ...options,
  }).format(value);
};

/**
 * Format currency according to locale
 */
export const formatCurrency = (
  value: number,
  currency: string = 'USD',
  locale: string = 'ar'
): string => {
  const localeCode = locale === 'ar' ? 'ar-SA' : 'en-US';
  return new Intl.NumberFormat(localeCode, {
    style: 'currency',
    currency,
  }).format(value);
};

/**
 * Parse a phone number string into country code and local number parts.
 * Handles formats: "+1 9302818325", "+1 19302818325", "+19302818325", "19302818325"
 */
export const parsePhoneNumber = (phoneNumber: string): { countryCode: string; localNumber: string } => {
  const str = (phoneNumber || '').trim();
  let countryCode = '+1';
  let localNumber = str;
  if (str.includes(' ')) {
    const parts = str.split(' ');
    countryCode = parts[0] || '+1';
    localNumber = parts.slice(1).join('');
  } else if (str.startsWith('+') && str.length > 2) {
    countryCode = str.slice(0, 2);
    localNumber = str.slice(2);
  }
  if (countryCode.startsWith('+')) {
    const dialCode = countryCode.slice(1);
    if (localNumber.startsWith(dialCode)) {
      localNumber = localNumber.slice(dialCode.length);
    }
  }
  return { countryCode, localNumber };
};

/**
 * Format percentage
 */
export const formatPercentage = (
  value: number,
  locale: string = 'ar'
): string => {
  const localeCode = locale === 'ar' ? 'ar-SA' : 'en-US';
  return new Intl.NumberFormat(localeCode, {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value / 100);
};

